import { render, staticRenderFns } from "./Lp.vue?vue&type=template&id=8456edb6&scoped=true&"
import script from "./Lp.vue?vue&type=script&lang=js&"
export * from "./Lp.vue?vue&type=script&lang=js&"
import style0 from "./Lp.vue?vue&type=style&index=0&id=8456edb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8456edb6",
  null
  
)

export default component.exports